import { ChatConnector } from "./connector-base";
import { NullChatConnector } from "./connector-null";

// Module level variable to hold the currently loaded and configured chat connector
const chatConnector: ChatConnector = new NullChatConnector();

export const getChatConnector = (): ChatConnector => {
    return chatConnector;
};
